<template>
    <div class="echarts-contain">
        <div class="top" v-if="showNum">单位({{unit}})</div>
        <div :id="id" class="o-echarts"></div>
        <!-- <div class="year" v-if="showYear">
            <div class="y-left" :style="'width:'+  (rightWidth == 1 ? 0.85 : (leftWidth == 1 ? 0.15 : leftWidth / data.length)) * 100 + '%'">{{leftYear}}年</div>
            <div
                class="y-right"
                v-if="rightWidth > 0"
                :style="'width:'+ (rightWidth == 1 ? 0.15 : (leftWidth == 1 ? 0.85 : rightWidth / data.length)) * 100 + '%'"
            >{{rightYear}}年</div>
        </div> -->
    </div>
</template>

<script>
    import echarts from 'echarts';

    export default {
        name: 'guideLineCharts',
        props: {
            data: {
                type: Array,
                default: () => {
                    return [{
                        xAxis: '',
                        num: ''
                    }]
                }
            },
            color: String, // 如果是green则绿色模式，否则是白色模式
            showYear: {
                type: Boolean,
                default: false
            },
            // interval: {
            //     type: Number,
            //     default: 0
            // },
            showNum: {
                type: Boolean,
                default: false
            },
            unit: {
                type: String,
                default: '分'
            },
            type: {
                type: String,
                default: ''
            }
        },
        data () {
            return {
                id:
                    'echarts_' +
                    new Date().getTime() +
                    Math.floor(Math.random() * 1000),
                echartObj: null,
                interval: 0,
                option: {}
            };
        },
        mounted () {
            this.option = {
                tooltip: {
                    show: true,
                    trigger: 'item',
                    confine: true,
                    triggerOn: 'mousemove',
                    formatter: params => {
                        // ${params.dataIndex <= this.leftWidth ? this.leftYear : this.rightYear}年
                        return `<p>${params.name}</p>${this.type === '' ? '' : '<p>' + this.type + '</p>'}<p>${params.value}${this.unit}</p>`;
                    }
                },
                xAxis: {
                    splitNumber: 100
                },
                dataZoom: [
                    {
                        zoomLock: true,
                        type: 'inside',
                        // realtime: true,
                        start: 60,
                        end: 100
                    }
                ],
                grid: {
                    top: '20%',
                    left: 60
                },

                yAxis: {
                    type: 'value',
                    // scale: true,
                    min: 0,
                    max: 10,
                    splitNumber: 5,
                    minInterval: 2,
                    boundaryGap: [ 0, 0.1 ],
                    axisLine: {
                        // y轴
                        show: false
                    },
                    // 网格样式
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color:
                                this.color === 'green' ? 'rgba(0, 0, 0, 0.08)' : 'rgba(255,255,255,0.1)',
                            width: 0.7,
                            type: 'solid'
                        }
                    },
                    // interval: 5,
                    axisTick: {
                        // y轴刻度线
                        show: false
                    },
                    axisLabel: {
                        show: true,
                        textStyle: {
                            color:
                                this.color === 'green' ? '#999999' : '#ffffff'
                        }
                    }
                },
                lineStyle: {
                    color:
                        this.color === 'green'
                            ? 'rgba(54,179,116,0)'
                            : 'rgba(255,255,255,1)',
                    width: 1
                },
                itemStyle: {
                    color:
                        this.color === 'green'
                            ? 'rgba(54,179,116,1)'
                            : 'rgba(255,255,255,1)',
                    opacity: 1
                },
                series: {}
            }
            this.echartObj = echarts.init(document.getElementById(this.id));
            this.echartObj.setOption(this.setSeriesData(), true);
        },
        watch: {
            data: {
                handler (newValue, oldValue) {
                    this.echartObj.setOption(this.setSeriesData(), true);
                    // for (let i = 0; i < newValue.length; i++) {
                    //     if (oldValue[i] !== newValue[i]) {
                    //         this.echartObj.setOption(this.setSeriesData(), true);
                    //     }
                    // }
                },
                deep: true
            }
        },
        computed: {
            leftYear () {
                return this.data[0] ? this.data[0].xAxis.substring(0, 4) : '';
            },
            rightYear () {
                let year = this.data[this.data.length - 1]
                    ? this.data[this.data.length - 1].xAxis.substring(0, 4)
                    : '';
                if (year === this.leftYear) {
                    year = '';
                }
                return year;
            },
            leftWidth () {
                let arr = [];
                this.data.forEach(item => {
                    if (item.xAxis.substring(0, 4) === this.leftYear) {
                        arr.push(arr);
                    }
                });
                return arr.length;
            },
            rightWidth () {
                let arr = [];
                this.data.forEach(item => {
                    if (item.xAxis.substring(0, 4) === this.rightYear) {
                        arr.push(arr);
                    }
                });
                return arr.length;
            }
        },
        methods: {
            // 尝试返回数据后刷新试图
            freshCharts () {
                this.echartObj.setOption(this.setSeriesData(), true);
            },
            getXaxisData () {
                // 填入横轴数据
                if (this.data.length > 0) {
                    return this.data.map(item => {
                        return item.xAxis.replace('-', '.') // .substring(5, 10) + '月';
                    });
                }
            },
            getSeriesData () {
                // 填入数据
                if (this.data.length > 0) {
                    return this.data.map(item => {
                        return item.num || 0;
                    });
                }
            },
            setSeriesData () {
                let sortList = JSON.parse(JSON.stringify(this.data))
                sortList.sort((x, y) => {
                    return x.num - y.num
                })
                let min = sortList[0] ? sortList[0].num : 0
                let max = sortList[sortList.length - 1] ? sortList[sortList.length - 1].num : 0
                min = max < 5 ? 0 : min
                max = max < 5 ? 5 : max
                if (min === max && min > 0) {
                    min = max - 5 < 0 ? 0 : max - 5
                }
                if (min === max && min === 0) {
                    max = 10
                }
                if (this.data.length < 7) {
                    this.option.dataZoom[0].start = 0
                } else {
                    this.option.dataZoom[0].start = 63.6363636
                }
                // this.option.yAxis.min = min
                // this.option.yAxis.max = max
                if (max <= 100) {
                    this.option.grid.left = 50
                }
                this.setOptions(
                    'xAxis',
                    (() => {
                        return {
                            type: 'category',
                            boundaryGap: false,
                            splitNumber: 1000,
                            minInterval: 100,
                            data: this.getXaxisData(),
                            axisLine: {
                                show: true,
                                lineStyle: {
                                    color:
                                        this.color === 'green'
                                            ? '#999999'
                                            : '#ffffff'
                                }
                            },
                            axisTick: {
                                // y轴刻度线
                                show: false
                            },
                            axisLabel: {
                                interval: this.interval,
                                show: true,
                                textStyle: {
                                    color:
                                        this.color === 'green'
                                            ? '#999999'
                                            : '#ffffff'
                                }
                            //   rotate: 60
                            }
                        };
                    })()
                );
                let that = this
                this.setOptions(
                    'series',
                    (() => {
                        return {
                            data: this.getSeriesData(),
                            type: 'line',

                            lineStyle: {
                                width: 1,
                                color: 'rgba(54,179,116,1)'
                            },
                            smooth: true,
                            symbol: 'circle', // 拐点设置为实心
                            symbolSize: 6, // 拐点大小
                            areaStyle: {
                                normal: {
                                    color: new echarts.graphic.LinearGradient(
                                        0,
                                        0,
                                        0,
                                        1,
                                        [
                                            {
                                                offset: 0,
                                                color:
                                                    this.color === 'green'
                                                        ? 'rgba(54,179,116,1)'
                                                        : 'rgba(255,255,255,1)'
                                            },
                                            {
                                                offset: 1,
                                                color:
                                                    this.color === 'green'
                                                        ? 'rgba(54,179,116,0)'
                                                        : 'rgba(255,255,255,0)'
                                            }
                                        ]
                                    )
                                }
                            },
                            itemStyle: {
                                normal: {
                                    color: '#fff', // 拐点颜色
                                    borderColor: 'rgba(54,179,116,1)', // 拐点边框颜色
                                    borderWidth: 1, // 拐点边框大小

                                    label: {
                                        show: true,
                                        color:
                                            this.color === 'green'
                                                ? 'rgba(54,179,116,1)'
                                                : 'rgba(255,255,255,1)',
                                        position: 'top',
                                        rotate: this.data[0]
                                            ? this.data[0].num > 99
                                                ? 0
                                                : 0
                                            : 0,
                                        formatter: function (param) {
                                            return param.value == '0'
                                                ? ''
                                                : (!that.showNum ? param.value.toFixed(2) : param.value.toLocaleString());
                                        }
                                    }
                                },
                                emphasis: {
                                    color: 'rgba(54,179,116,1)' // hover拐点颜色定义
                                }
                            }
                        };
                    })()
                );
                return this.option;
            },
            setOptions (objKey, objVal) {
                if (
                    this.option[objKey] &&
                    typeof this.option[objKey] === 'object' &&
                    !Array.isArray(this.option[objKey])
                ) {
                    this.option[objKey] = Object.assign(
                        this.option[objKey],
                        objVal
                    );
                } else {
                    this.option[objKey] = objVal;
                }
                this.$set(this.option, objKey, this.option[objKey]);
            }
        }
    };
</script>

<style lang="less" scoped>
.echarts-contain {
    width: 100%;
    height: 100%;
    position: relative;
    top:-10px!important;
    .o-echarts {
        width: 100%;
        height: 100%;
    }
    .top {
        position: absolute;
        font-size: 10px;
        color: #999999;
        left: 14px;
        top: 10px;
    }
    .year {
        position: absolute;
        bottom: 10px;
        padding: 0 8px 0 32px;
        width: 100%;
        height: 20px;
        display: flex;
        align-items: center;
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #999999;
        text-align: center;
        // .y-left{
        //     text-align: center;
        // }
        .y-right {
            border-left: 1px solid #eeeeee;
        }
    }
    .mt5 {
        margin-bottom: 5px;
    }
    // /deep/canvas{
    //     top:-10px!important;
    //     // width: 358px!important;
    // }
}
</style>
